import React, { useState } from "react";
import {
  FaCoins,
  FaCrown,
  FaHistory,
  FaMedal,
  FaMoneyBillWave,
  FaRegUser,
  FaTrophy,
  FaWallet,
  FaGift,
  FaShareAlt,
  FaUsers,
  FaWhatsapp,
} from "react-icons/fa";

const ProfilePage = () => {
  const userStats = {
    name: "John Doe",
    rank: "Pro Bettor",
    totalBets: 156,
    winRate: "68%",
    balance: "₹24,680",
    winnings: "₹12,450",
    bonus: "₹500",
  };

  const [activeTab, setActiveTab] = useState("betting");

  const tabs = [
    { id: "betting", label: "Betting History" },
    { id: "transactions", label: "Transactions" },
    { id: "achievements", label: "Achievements" },
  ];

  const recentBets = [
    {
      title: "CSK vs MI",
      amount: "₹500",
      status: "won",
      date: "2 hours ago",
      profit: "+₹950",
    },
    {
      title: "RCB vs GT",
      amount: "₹200",
      status: "lost",
      date: "5 hours ago",
      profit: "-₹200",
    },
    {
      title: "KKR vs LSG",
      amount: "₹1000",
      status: "won",
      date: "Yesterday",
      profit: "+₹1800",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-900 pb-20">
      {/* Profile Header */}
      <div className="bg-gradient-to-b from-blue-900/50 to-gray-900 pt-6 pb-8">
        <div className="max-w-lg mx-auto px-4">
          <div className="flex items-center gap-4">
            <div className="w-24 h-24 rounded-full border-2 border-blue-500 p-1">
              <div className="w-full h-full rounded-full bg-gray-700 flex items-center justify-center">
                <FaRegUser className="w-12 h-12 text-gray-400" />
              </div>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">
                {userStats.name}
              </h1>
              <div className="flex items-center gap-2 mt-1">
                <div className="bg-blue-500/20 text-blue-400 px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1">
                  <FaCrown className="text-yellow-500" />
                  {userStats.rank}
                </div>
              </div>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-3 gap-4 mt-6">
            <StatCard
              icon={FaHistory}
              label="Total Bets"
              value={userStats.totalBets}
            />
            <StatCard
              icon={FaTrophy}
              label="Win Rate"
              value={userStats.winRate}
            />
            <StatCard icon={FaMedal} label="Rank" value="#126" />
          </div>
        </div>
      </div>

      {/* Wallet Section */}
      <div className="max-w-lg mx-auto px-4 -mt-4">
        <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-xl p-4">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-white">Wallet Balance</h2>
            <FaWallet className="text-blue-500" />
          </div>
          <div className="grid grid-cols-3 gap-4">
            <BalanceCard
              icon={FaMoneyBillWave}
              label="Total Balance"
              value={userStats.balance}
              primary
            />
            <BalanceCard
              icon={FaCoins}
              label="Total Winnings"
              value={userStats.winnings}
            />
            <BalanceCard
              icon={FaCrown}
              label="Active Bonus"
              value={userStats.bonus}
            />
          </div>
        </div>
      </div>

      {/* Refer & Earn Section */}
      <div className="max-w-lg mx-auto px-4 mt-6">
        <div className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-sm border border-blue-500/20 rounded-xl p-6 relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-purple-500/10 rounded-full translate-y-1/2 -translate-x-1/2" />

          {/* Content */}
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-xl font-bold text-white mb-2">
                Refer & Earn
              </h3>
              <p className="text-gray-300 text-sm mb-4">
                Get ₹100 bonus for every friend who joins and places their first
                bet
              </p>

              {/* Stats */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-gray-800/50 rounded-lg p-3">
                  <div className="flex items-center gap-2 mb-1">
                    <FaUsers className="text-blue-400" />
                    <span className="text-gray-400 text-sm">Referrals</span>
                  </div>
                  <p className="text-xl font-bold text-white">12</p>
                </div>
                <div className="bg-gray-800/50 rounded-lg p-3">
                  <div className="flex items-center gap-2 mb-1">
                    <FaGift className="text-green-400" />
                    <span className="text-gray-400 text-sm">Earned</span>
                  </div>
                  <p className="text-xl font-bold text-white">₹1,200</p>
                </div>
              </div>

              {/* Referral Code */}
              <div className="bg-gray-800/80 rounded-lg p-3 mb-4">
                <p className="text-xs text-gray-400 mb-1">Your Referral Code</p>
                <div className="flex items-center justify-between">
                  <span className="text-lg font-mono font-bold text-white tracking-wider">
                    WINS100
                  </span>
                  <button
                    onClick={() => navigator.clipboard.writeText("WINS100")}
                    className="text-blue-400 hover:text-blue-300 text-sm bg-blue-500/10 px-3 py-1 rounded-md transition-colors"
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Share Buttons */}
          <div className="flex gap-3">
            <button className="flex-1 bg-green-600/90 hover:bg-green-500/90 text-white py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2">
              <FaWhatsapp />
              <span className="text-sm">Share on WhatsApp</span>
            </button>
            <button className="bg-gray-700/50 hover:bg-gray-700 text-white p-2 rounded-lg transition-colors">
              <FaShareAlt />
            </button>
          </div>

          {/* Terms */}
          <p className="text-gray-400 text-xs mt-4">
            *Terms and conditions apply. Referral bonus will be credited after
            friend's first bet.
          </p>
        </div>
      </div>
    </div>
  );
};

const StatCard = ({ icon: Icon, label, value }) => (
  <div className="bg-gray-800/30 backdrop-blur-sm rounded-lg p-3 text-center">
    <Icon className="w-5 h-5 text-blue-400 mx-auto mb-1" />
    <div className="text-sm text-gray-400">{label}</div>
    <div className="text-white font-semibold">{value}</div>
  </div>
);

const formatIndianCurrency = (value) => {
  const num = parseInt(value.replace(/[^0-9]/g, ""));
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(num);
};

const BalanceCard = ({ icon: Icon, label, value, primary }) => (
  <div
    className={`rounded-lg p-3 ${
      primary ? "bg-blue-600/20 border border-blue-500/50" : "bg-gray-800/30"
    }`}
  >
    <Icon
      className={`w-5 h-5 ${primary ? "text-blue-400" : "text-gray-400"} mb-1`}
    />
    <div className="text-xs text-gray-400">{label}</div>
    <div className="text-white font-semibold">
      {formatIndianCurrency(value)}
    </div>
  </div>
);

const ActivityCard = ({ title, amount, status, date, profit }) => (
  <div className="border-b border-gray-800 py-3">
    <div className="flex justify-between items-center">
      <div>
        <div className="text-white font-medium">{title}</div>
        <div className="text-sm text-gray-400">Bet Amount: {amount}</div>
      </div>
      <div className="text-right">
        <div className={status === "won" ? "text-green-400" : "text-red-400"}>
          {formatIndianCurrency(profit)}
        </div>
        <div className="text-xs text-gray-400">{date}</div>
      </div>
    </div>
  </div>
);

export default ProfilePage;
